/*
 * user (zod)
 */
import { globalAtExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { users } from "./user.schema"

/* Select */
export type User = z.infer<typeof selectUserSchema>
export const selectUserSchema = createSelectSchema(users)

/* Filters */
export type UserFilters = z.infer<typeof userFiltersSchema>
export const userFiltersSchema = z.object({
	id: z.string().optional(),
})

/* Create */
export const createUserSchema = createInsertSchema(users).omit(globalAtExclude)
export type CreateUser = z.infer<typeof createUserSchema>

/* Update */
export const updateUserSchema = createInsertSchema(users)
	.omit(globalAtExclude)
	.partial()
	.required({ id: true })
export type UpdateUser = z.infer<typeof updateUserSchema>
